<template>
  <div class="text-center">
    <v-icon :color="color" :class="iconClass" class="loading-icon">{{
      icon
    }}</v-icon>
    <span :color="color" :class="size" class="loading-text">{{ text }}</span>
  </div>
</template>

<script>
export default {
  name: "Loader",
  props: {
    icon: {
      type: String,
      default: "fas fa-circle-notch fa-spin",
    },
    text: {
      type: String,
      default: "Loading...",
    },
    color: {
      type: String,
      default: "black",
    },
    size: {
      validator: function (value) {
        return (
          [
            "standard",
            "x-small",
            "small",
            "medium",
            "large",
            "x-large",
          ].indexOf(value) !== -1
        );
      },
      default: "standard",
    },
  },
  computed: {
    iconClass() {
      let cssClass = {};
      cssClass[this.size] = true;
      cssClass["mr-3"] = this.text;

      if (this.size === "x-large") {
        cssClass["xl-top-fix"] = true;
      }

      return cssClass;
    },
  },
};
</script>

<style scoped>
.x-small {
  font-size: 10px;
}
.small {
  font-size: 16px;
}
.standard {
  font-size: 24px;
}
.medium {
  font-size: 28px;
}
.large {
  font-size: 36px;
}
.x-large {
  font-size: 40px;
}
.xl-top-fix {
  top: -10px;
}
</style>
